
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const COOKIE_KEY = 'engeporto_cookie_consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_KEY, 'declined');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 200, damping: 28 }}
          className="fixed bottom-0 left-0 right-0 z-[9999] bg-[#0A1628] border-t-2 border-[#D4AF37] shadow-2xl"
          role="dialog"
          aria-label="Consentimento de cookies"
        >
          <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8">
            {/* Ícone */}
            <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-[#D4AF37]/10 rounded-full">
              <i className="ri-cookie-line text-[#D4AF37] text-xl"></i>
            </div>

            {/* Texto */}
            <div className="flex-1 min-w-0">
              <p className="text-sm text-white font-medium mb-1">
                🍪 Utilizamos cookies para melhorar sua experiência
              </p>
              <p className="text-xs text-neutral-300 leading-relaxed">
                Este site usa cookies essenciais e de análise para garantir o funcionamento correto e aprimorar nossos serviços.
                Ao continuar navegando, você concorda com nossa{' '}
                <Link
                  to="/politica-privacidade"
                  className="text-[#D4AF37] underline underline-offset-2 hover:text-[#C4A137] transition-colors whitespace-nowrap"
                  onClick={handleAccept}
                >
                  Política de Privacidade
                </Link>
                .
              </p>
            </div>

            {/* Botões */}
            <div className="flex items-center gap-3 flex-shrink-0">
              <button
                onClick={handleDecline}
                className="px-4 py-2 text-xs font-medium text-neutral-300 border border-neutral-600 rounded-md hover:border-neutral-400 hover:text-white transition-all whitespace-nowrap cursor-pointer"
              >
                Recusar
              </button>
              <button
                onClick={handleAccept}
                className="px-5 py-2 text-xs font-semibold bg-[#D4AF37] text-[#0A1628] rounded-md hover:bg-[#C4A137] transition-all whitespace-nowrap cursor-pointer"
              >
                Aceitar todos
              </button>
            </div>

            {/* Fechar */}
            <button
              onClick={handleDecline}
              aria-label="Fechar banner de cookies"
              className="absolute top-3 right-4 w-7 h-7 flex items-center justify-center text-neutral-400 hover:text-white transition-colors cursor-pointer md:static md:flex-shrink-0"
            >
              <i className="ri-close-line text-lg"></i>
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
